import { render, staticRenderFns } from "./land.vue?vue&type=template&id=0134c2e8&"
import script from "./land.vue?vue&type=script&lang=js&"
export * from "./land.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports